/**
 * Registration components
 */

import { createRouter, createWebHistory } from 'vue-router';

const baseUrl = '/register';
const registrationRouter = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: `${baseUrl}`,
      name: 'register',
      component: () => import(/* webpackChunkName: "group-registration" */ '@/components/authentication/register-page/stages/register-stage-login-info'),
      meta: { linkTo: `${baseUrl}/personal-info`, index: 0 },
    },
    {
      path: `${baseUrl}/personal-info`,
      name: 'personal-info',
      component: () => import(/* webpackChunkName: "group-registration" */ '@/components/authentication/register-page/stages/register-stage-personal-info'),
      meta: { linkTo: 'job-preferences', index: 1 },
    },
    {
      path: `${baseUrl}/job-preferences`,
      name: 'job-preferences',
      component: () => import(/* webpackChunkName: "group-registration" */ '@/components/authentication/register-page/stages/register-stage-job-preference'),
      meta: { linkTo: 'job-roles', index: 2 },
    },
    {
      path: `${baseUrl}/job-roles`,
      name: 'job-roles',
      component: () => import(/* webpackChunkName: "group-registration" */ '@/components/authentication/register-page/stages/register-stage-job-roles'),
      meta: { linkTo: process.env.DIVERSITY_DATA_ENABLED ? 'diversity' : 'newsletter', index: 3 },
    },
    {
      path: `${baseUrl}/diversity`,
      name: 'diversity',
      component: () => import(/* webpackChunkName: "group-registration" */ '@/components/authentication/register-page/stages/register-stage-diversity'),
      meta: { linkTo: 'newsletter', index: 4 },
    },
    {
      path: `${baseUrl}/newsletter`,
      name: 'newsletter',
      component: () => import(/* webpackChunkName: "group-registration" */ '@/components/authentication/register-page/stages/register-stage-newsletter'),
      meta: { linkTo: 'dashboard', index: 5 },
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

console.log('process.env.DIVERSITY_DATA_ENABLED', process.env.DIVERSITY_DATA_ENABLED);
export default registrationRouter;
